import { useLocation } from "react-router-dom";
import AppRoutes from "../routing/app-routes";
import HeaderMain from "../app/sections/common/header";
import Footer from "../app/sections/common/footer";

function RootLayout() {
  const location = useLocation();

  const shouldHide =
    location.pathname === "/login" ||
    location.pathname === "/registration" ||
    location.pathname.startsWith("/config") ||
    location.pathname.startsWith("/agents") ||
    location.pathname.startsWith("/web-admin") ||
    location.pathname.startsWith("/pms");
  const configurePathRoutes = [
    "/config/products/configure",
    "/agents/config/products/lite-special",
    "/agents/config/products/advanced-inventory",
  ];
  const shouldClear = !configurePathRoutes.includes(location.pathname);
  shouldClear && sessionStorage.removeItem("configurePath");

  return (
    <>
      <AppRoutes />
    </>
  );
}

export default RootLayout;
